import { useMediaQuery } from '@mantine/hooks';

/**
 * Hook to detect mobile viewport.
 * Uses 991px breakpoint consistent with Mantine's 'md' breakpoint (992px).
 *
 * Uses getInitialValueInEffect: false to evaluate the media query synchronously
 * on the first render. This is safe because the app is a Vite SPA (no SSR), so
 * there are no hydration mismatches to worry about. Evaluating synchronously
 * prevents downstream hooks (e.g., useDashboardData) from seeing a value flip
 * from false→true after mount, which would change React Query keys and trigger
 * duplicate network requests.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 991px)', false, { getInitialValueInEffect: false }) ?? false;
}
